module.exports = __webpack_public_path__ + "img/picc.49f03270.png";